export default __webpack_public_path__ + "static/media/electricCar.3a6d0a6f.svg";